export const ACCESS_TOKEN = 'accessToken';
export const EXPIRES_ON = 'expiresOn';
export const ACCOUNT = 'account';
export const TIME_OF_AUTO_LOGOUT = 'timeOfAutoLogout';
export const REFRESH_TOKEN = 'refreshToken';
export const ID_TOKEN = 'idToken'
